export default "__VITE_ASSET__B8l2uCeq__"